import { oFormInput, TextEditor } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    align-items: flex-end;
`;

export const CountryEditor = styled(TextEditor)`
    ${oFormInput};
    width: 68px;
    border-radius: 2px 0 0 2px;

    &:focus {
        z-index: 1;
    }
`;

export const AreaEditor = styled(TextEditor)`
    ${oFormInput};
    width: 68px;
    border-radius: 0;
    margin-left: -1px;
    margin-right: -1px;

    &:focus {
        z-index: 1;
    }
`;

export const NumberEditor = styled(TextEditor)`
    flex: 1;
    ${oFormInput};
    border-radius: 0 2px 2px 0;

    &:focus {
        z-index: 1;
    }
`;
